import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '子系统实例',
    type: 'PHYS_DEPLOYED_SSINS',
}
